module.exports = __webpack_public_path__ + "static/media/Lion Face981_1c.6199be25.svg";